<template>
  <v-tooltip :location="location" :max-width="maxWidth">
    <template v-slot:activator="{ props }">
      <!--
        チェックボックスの label の中に置くとアイコンのクリックで値が変わってしまうため、
        クリックとスペースキーは飲み込む。説明はホバーとフォーカスで出す。
      -->
      <v-icon
        v-bind="props"
        :size="size"
        class="info-tip"
        color="grey-darken-1"
        tabindex="0"
        role="img"
        aria-label="説明"
        @click.stop.prevent
        @keydown.space.stop.prevent
      >
        mdi-information-outline
      </v-icon>
    </template>
    <slot>{{ text }}</slot>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue";

/**
 * 項目名の横に置く「?」相当の説明アイコン。
 * 短い注意書きは hint (フィールド下の小さい文字) に、
 * 読まなくても操作できる補足はこちらに置く。
 *
 * 文言は text か既定スロットで渡す (改行やリンクを入れたいときはスロット)。
 */
export default defineComponent({
  name: "InfoTip",

  props: {
    text: {
      type: String,
      default: "",
    },
    location: {
      type: String,
      default: "top",
    },
    maxWidth: {
      type: [Number, String],
      default: 320,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
  },
});
</script>

<style scoped>
.info-tip {
  cursor: help;
}
</style>
